module.exports = __webpack_public_path__ + "static/media/book-cover-light-pink.45ae426c.jpg";